import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GungBase, GungFlowService, Product } from 'gung-standard';
import { BehaviorSubject, Observable } from 'rxjs';
import { first, switchMap, tap } from 'rxjs';

export interface PimProductConcept extends GungBase {
  i18n: any;
  dateLastUpdate: Date;
  images: any[];
}

@Injectable({
  providedIn: 'root'
})
export class ColmecPimConceptsService {
  baseUrl = 'json/pim/concepts';
  colmecBaseUrl = 'json/colmec/pim/concepts';

  private pimConceptsSubject: BehaviorSubject<PimProductConcept[]>;

  constructor(protected http: HttpClient, protected gungFlowService: GungFlowService) {}

  private internalGetAllConcepts(nocache?: boolean): Observable<PimProductConcept[]> {
    const url = this.baseUrl;
    const headers = {
      maxAge: nocache ? '-1' : '300'
    };
    return this.http.get<PimProductConcept[]>(`${url}`, { headers });
  }

  updateConceptsSubject(nocache?: boolean): Observable<PimProductConcept[]> {
    if (!this.pimConceptsSubject) {
      return;
    }
    return this.internalGetAllConcepts(nocache).pipe(
      first(),
      tap((data: PimProductConcept[]) => this.pimConceptsSubject.next(data)),
      switchMap(_ => this.pimConceptsSubject)
    );
  }

  getAllConcepts(nocache?: boolean) {
    if (!this.pimConceptsSubject) {
      this.pimConceptsSubject = new BehaviorSubject<PimProductConcept[]>([]);
      return this.updateConceptsSubject(nocache);
    }
    return this.pimConceptsSubject.asObservable();
  }

  getConceptById(id: string) {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<PimProductConcept>(url);
  }

  getProductsByConceptById(id: string): Observable<Product[]> {
    return this.gungFlowService.getSelectedFlow().pipe(
      first(),
      switchMap(selectedFlow => {
        const flowId = selectedFlow.id;
        const url = `${this.colmecBaseUrl}/products/${id}?flowId=${flowId}`;
        return this.http.get<Product[]>(url);
      })
    );
  }
}
